import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// import arrowOutwardWhite from "@/assets/images/user/arrowOutwardWhite.svg";
import logo from "@/assets/images/user/logo.svg";
import { ScrollArea } from "@/components/ui/scroll-area";

import SnsLink from "./SnsLink";

export default function Header() {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuHover, setMenuHover] = useState<number | null>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuOn, setMenuOn] = useState<number | null>(null);
    const menuList = [
        {
            title: "GXG",
            subMenu: [
                { title: "GXG 소개", link: "/about" },
                { title: "오시는 길", link: "/location" },
                { title: "행사장 구성", link: "/map" },
            ],
        },
        {
            title: "프로그램",
            subMenu: [
                { title: "행사 스케줄", link: "/schedule" },
                { title: "THE STAGE", link: "/program/stage" },
                { title: "THE PLAY", link: "/program/play" },
                { title: "THE ART", link: "/program/art" },
                { title: "THE FOCUS", link: "/program/focus" },
                { title: "THE FESTA", link: "/program/festa" },
            ],
        },
        {
            title: "아카이브",
            subMenu: [
                { title: "GXG HISTORY", link: "/archive/history" },
                { title: "SOUND TRACK", link: "/archive/soundtrack" },
            ],
        },
        {
            title: "커뮤니티",
            subMenu: [
                { title: "공지사항", link: "/community/166" },
                { title: "관련자료", link: "/community/171" },
                { title: "자주 묻는 질문", link: "/community/faq" },
                { title: "CONTACT US", link: "/community/contact" },
            ],
        },
    ];

    // 스크롤시 헤더 배경색 변경
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // 페이지 이동시 모바일메뉴 닫기
    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <header
            className={
                "fixed top-0 left-0 w-full z-[50] transition-all " +
                "before:absolute before:content-[''] before:w-full before:h-[1px] before:top-[20px] before:bg-white before:left-0 before:z-[60] " +
                "after:absolute after:content-[''] after:w-full after:h-[65px] after:left-0 after:-bottom-[1px] after:translate-y-full after:bg-[rgba(0,0,0,0.8)] " +
                "md:before:top-[24px] xl:border-b xl:border-white xl:before:top-[50px] " +
                (menuHover !== null
                    ? "bg-[rgba(0,0,0,0.8)] after:block"
                    : isScrolled
                      ? "bg-[rgba(0,0,0,0.8)] after:hidden"
                      : "after:hidden")
            }
        >
            <div className="relative max-w-[1600px] w-full mx-auto flex justify-between items-center pt-[20px] after:absolute after:content-[''] after:w-full after:h-[1px] after:bg-white after:left-0 after:bottom-0 md:pt-[24px] xl:pt-[50px] xl:after:hidden">
                <div className="relative px-[20px] flex-1 flex items-center gap-[70px] md:px-[40px] xl:p-[0_0_0_60px]">
                    <div className="py-[18px] xl:py-0">
                        <Link to={``}>
                            <img src={logo} alt="GXG2025" />
                        </Link>
                    </div>
                    <ul className="hidden flex-1 z-[70] xl:flex" onMouseLeave={() => setMenuHover(null)}>
                        {menuList.map((menu, i) => (
                            <li
                                key={`menu_${i}`}
                                className="max-w-[200px] w-full relative group"
                                onMouseEnter={() => setMenuHover(i)}
                            >
                                <Link
                                    to={menu.subMenu && menu.subMenu[0] ? menu.subMenu[0].link : "#"}
                                    className={`flex justify-center items-center leading-[26px] py-[20px] relative
                                        after:absolute after:content-[''] after:w-full after:h-full after:left-0 after:top-0 after:border after:border-solid after:border-[1px] after:opacity-0 after:transition-all after:duration-200 after:pointer-events-none after:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] group-hover:after:opacity-100`}
                                >
                                    <span
                                        className={`
                                            text-[22px] font-['GongGothicMedium'] transition-colors text-white group-hover:text-primary
                                        `}
                                    >
                                        {menu.title}
                                    </span>
                                </Link>
                                {menuHover === i && (
                                    <ul
                                        className={`absolute bottom-0 translate-y-full flex ${i === 1 || i === 3 ? "left-1/2 -translate-x-1/2" : "left-0"}`}
                                    >
                                        {menu.subMenu.length > 0 ? (
                                            menu.subMenu.map((subMenu, j) => (
                                                <li key={`sub_menu_${j}`} className="flex-none w-[200px]">
                                                    <Link
                                                        to={subMenu.link}
                                                        className="block text-[20px] font-[500] text-[rgba(255,255,255,0.6)] font-['GongGothicMedium'] relative leading-[26px] py-[20px] transition-all text-center after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[4px] after:bg-gradient-to-r after:from-[#E64C88] after:to-[#3734C3] after:opacity-0 after:transition-all hover:text-white hover:after:opacity-100"
                                                    >
                                                        {subMenu.title}
                                                    </Link>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="text-[20px] font-[500] text-[rgba(255,255,255,0.6)] font-['GongGothicMedium'] h-[26px] py-[20px] text-center w-[200px]">
                                                COMING SOON
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <SnsLink className="hidden xl:flex" /> */}
                {/* <Link
                    to={`/landing`}
                    className="fixed right-0 bottom-0 w-[305px] h-[62px] z-50 border border-primary flex items-center bg-black text-[16px] text-white font-['GongGothicMedium'] group xl:w-auto xl:h-[66px] xl:static xl:bg-transparent xl:border-none xl:border-white xl:flex xl:items-center xl:text-[20px]"
                >
                    <p className="tracking-normal flex-1 flex justify-center items-start py-[19px] transition-all duration-300 xl:px-[24px] xl:border-r xl:border-l xl:border-white xl:group-hover:bg-black">
                        <span>GXG 2</span>
                        <span className="text-[12px] xl:text-[14px]">nd&nbsp;&nbsp;</span>
                        <span>SOUND TRACK</span>
                    </p>
                    <span className="bg-primary size-[62px] flex items-center justify-center transition-all duration-300 xl:px-[10px] xl:size-[66px] xl:border-t xl:border-r xl:border-white xl:bg-transparent xl:group-hover:bg-primary">
                        <img src={arrowOutwardWhite} alt="화살표" />
                    </span>
                </Link> */}
                {/* 모바일일때만 노출 */}
                <button
                    type="button"
                    className="absolute right-[20px] top-[calc(50%+10px)] size-[40px] -translate-y-1/2 z-[200] md:top-[calc(50%+12px)] md:right-[40px] xl:hidden"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span
                        className={`w-[30px] h-[3px] bg-white absolute left-1/2 top-1/2 transition-all transform duration-500 -translate-x-1/2  ${menuOpen ? "rotate-45 -translate-y-1/2" : "-translate-y-[calc(50%+9px)]"}`}
                    />
                    <span
                        className={`w-[30px] h-[3px] bg-white absolute left-1/2 top-1/2 transition-all transform duration-500 -translate-x-1/2 -translate-y-1/2${menuOpen ? " opacity-0" : ""}`}
                    />
                    <span
                        className={`w-[30px] h-[3px] bg-white absolute left-1/2 top-1/2 transition-all transform duration-500 -translate-x-1/2  ${menuOpen ? "-rotate-45 -translate-y-1/2" : "-translate-y-[calc(50%-9px)]"}`}
                    />
                </button>
                <div
                    className={`
                        fixed p-[86px_20px_30px] inset-0 w-full h-full z-[100] transition-all duration-300 bg-bgGnb bg-center bg-cover flex flex-col justify-between xl:hidden
                        ${menuOpen ? "opacityb-100 visible" : "opacity-0 invisible"}
                    `}
                >
                    <ScrollArea className="h-[calc(100%-50px)]">
                        <ul className="flex flex-col gap-[50px] md:gap-[100px]">
                            {menuList.map((menu, i) => (
                                <li key={`menu_${i}`}>
                                    <button
                                        type="button"
                                        className={`text-[30px] font-[500] transition-all font-['GongGothicMedium'] md:text-[50px] ${menuOn === i ? "text-primary" : "text-white"}`}
                                        onClick={() => setMenuOn(menuOn === i ? null : i)}
                                    >
                                        {menu.title}
                                    </button>
                                    <ul
                                        className={`flex flex-col gap-[10px] overflow-hidden transition-all ${menuOn === i ? "pt-[12px] h-auto opacity-100 md:pt-[20px]" : "h-0 opacity-0"}`}
                                    >
                                        {menu.subMenu.length > 0 ? (
                                            menu.subMenu.map((subMenu, j) => (
                                                <li key={`sub_menu_${j}`}>
                                                    <Link
                                                        to={subMenu.link}
                                                        className="font-['GongGothicMedium'] text-[16px] text-[rgba(255,255,255,0.6)] py-[6px] relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[4px] after:bg-gradient-to-r after:from-[#E64C88] after:to-[#3734C3] after:opacity-0 after:transition-all hover:text-white hover:after:opacity-100 md:text-[20px] md:py-[24px]"
                                                    >
                                                        {subMenu.title}
                                                    </Link>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="w-full font-['GongGothicMedium'] text-[20px] text-[rgba(255,255,255,0.6)] text-center py-[16px] md:py-[24px]">
                                                COMING SOON
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </ScrollArea>
                    <SnsLink />
                </div>
                {/* // 모바일일때만 노출 */}
            </div>
        </header>
    );
}
